export class Profile {
    companyId: string
    slug: string
    domain?: string
    createdAt: Date
    updatedAt: Date
    status: number
    timezone: number
    profileTitle?: string
    profileBio?: string
    profilePicture?: string
    themePrimaryColor?: string
    themeSecondaryColor?: string
    themeBackgroundColor?: string
    themeFavicon?: string
    seoTitle?: string
    seoDescription?: string
    links?: any[]
    services?: any[]
    schedulerOnline?: boolean
    schedulerAllowConsulting?: boolean
    schedulerShowPrice?: boolean
    schedulerPreviousTimeMinMinutes?: number
    schedulerPreviousTimeMaxDays?: number

    themeHeaderBackgroundColor: string
    themeHeaderTextColor: string
    themeHeaderFormat: string
    themeTextColor: string
    schedulerOnlyWith: string
    schedulerOnlywithRecentDays: number
    schedulerMissesLimit: number
    schedulerBlockDuplicity: boolean

    schedulerShowDescription: boolean
    schedulerAllowMultiple: boolean
    schedulerStartBy: string
    googleShowReviews: boolean
    googleShowRating: boolean

    gpsAddress: string
}
